// Below are the standard tags that can be assigned to a user and/or a user group.
export const permissionTags = {
  user_manager: {},
  organization_manager: {},
  admin: {},
  screener: {},
  reviewer: {},
  support: {},
} as const;

export type PermissionTag = keyof typeof permissionTags;

export const restrictionTags = {
  'no-tabs': {},
  'read-only': {},
} as const;

export type RestrictionTag = keyof typeof restrictionTags;

export const standardTags = { ...permissionTags, ...restrictionTags } as const;

export type StandardTag = keyof typeof standardTags;

// Name and description are strings because of i18n, we don't need to directly declare what string they are as these can be dynamic.
export type StandardTagName = string;
export type StandardTagDescription = string;

export const isStandardTag = (tag: string): tag is StandardTag => {
  return tag in standardTags;
}

export const isPermissionTag = (tag: string): tag is PermissionTag => {
  return tag in permissionTags;
}

export const isRestrictionTag = (tag: string): tag is RestrictionTag => {
  return tag in restrictionTags;
}